<template>
  <el-dialog title="订单发货" :visible.sync="dialogVisible" width="500px" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
    <el-form v-if="order" ref="deliveryForm" :model="shipmentInfo" :rules="rules" label-width="100px">
      <el-form-item label="订单编号">{{ order.orderNumber }}</el-form-item>
      <el-form-item label="支付单号">{{ order.payNumber }}</el-form-item>
      <el-form-item label="快递公司" prop="logisticsCode">
        <el-select v-model="shipmentInfo.logisticsCode" class="max-width" filterable clearable placeholder="请选择快递公司">
          <el-option v-for="(item, index) in deliveries" :key="index" :label="item.deliveryName" :value="item.deliveryId">
            <span>{{ item.deliveryName }}</span>
            <span>{{ item.deliveryId }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号" prop="logisticsNumber">
        <el-input v-model="shipmentInfo.logisticsNumber" class="max-width" placeholder="请输入快递单号" clearable />
      </el-form-item>
    </el-form>

    <template v-slot:footer>
      <el-button @click="handleCancel">取　消</el-button>
      <el-button type="primary" @click="handleSubmit">确定提交</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { orderShipment } from '@/api/order'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      shipmentInfo: {
        logisticsNumber: '',
        logisticsCode: ''
      },
      rules: {
        logisticsCode: [{ required: true, message: '请选择快递公司', trigger: 'change' }],
        logisticsNumber: [{ required: true, message: '请输入快递单号', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device,
      deliveries: state => state.base.deliveryList
    })
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    },
    order: {
      immediate: true,
      handler(value) {
        this.shipmentInfo = Object.assign({}, value)
      }
    }
  },
  methods: {
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    },
    handleCancel() {
      this.dialogClose()
    },
    handleSubmit() {
      this.$refs.deliveryForm.validate(valid => {
        if (!valid) return false

        const delivery = this.deliveries.find(item => item.deliveryId === this.shipmentInfo.logisticsCode)
        if (delivery) this.shipmentInfo.logisticsName = delivery.deliveryName

        orderShipment(this.shipmentInfo).then(response => {
          this.$message.info(response)
          this.shipmentInfo.orderStatus = 31
          this.shipmentInfo.orderStatusName = '已发货'
          this.$emit('update:order', this.shipmentInfo)
          this.$emit('refresh')
          this.dialogClose()
        }).catch(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .max-width {
    max-width: 90%;
  }
  .mobile {
    .max-width {
      max-width: 100%;
    }
  }
  .el-select-dropdown__item {
    display: flex;
    justify-content: space-between;
  }
</style>
